import { deserify, HelpSupport } from '@geneo2-web/shared-ui';
import { useNavigate } from 'react-router-dom';
import { FAQ } from '../../../routeHandling/RoutesNomenclature';
import { useAppSelector } from '../../../reduxStore/reduxHooks';

interface IProps {}

export const HelpAndSupport = (props: IProps) => {
  const navigate = useNavigate();
  const { user_validation_info, userInfo } = deserify(
    useAppSelector((state) => state.auth)
  );

  return (
    <HelpSupport
      onFaqClick={() => navigate(FAQ)}
      schoolId={userInfo?.schoolDetails?.schoolId}
    />
  );
};
